import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { getApiBaseUrl } from 'data/helpers';
import { UserSettingsProvider } from '../../settings/hooks';

export function withUserSettingsContext<TProps extends {}>(
	app: PiletApi,
	Component: React.FC<TProps>
): React.FC<TProps> {
	const WrappedComponent: React.FC<TProps> = props => (
		<UserSettingsProvider
			piletApi={app}
			pluginName="contentqna"
			pluginBaseUrl={getApiBaseUrl(app, 'contentqna')}
			apiVersion="v1"
		>
			<Component {...props} />
		</UserSettingsProvider>
	);
	return WrappedComponent;
}
